import { CATALOGS, CACHE_TTL } from '@/helpers/constants';
import { i18n } from '@/plugins/i18n';

const DEFAULT_CACHE_TIME = CACHE_TTL.twoMinutes;

export const catalog = {
    methods: {
        async getCatalog(type, cacheTime = DEFAULT_CACHE_TIME) {
            const cacheData = this.getItemCatalog(type, cacheTime);

            if (cacheData) {
                return cacheData;
            }

            const catalog = await this.fetchCatalog(type);
            this.setItemCatalog(type, catalog);

            return catalog;
        },

        getDescription(value, catalog) {
            if (!value) {
                return '';
            }

            const tmp = catalog.find(item => +item.id === +value);

            return tmp ? tmp.description : '';
        },

        async fetchCatalog(type) {
            const headers = { 'X-Language': localStorage.getItem('locale') };
            const item = CATALOGS.find(item => item.type === type);

            if (!item.url) {
                return;
            }

            const url = 'catalogs/' + item.url;
            const response = await this.axios.get(url, { headers });

            return response.data;
        },

        setItemCatalog(type, data) {
            const cache = {
                data,
                timestamp: Date.now(),
                language: i18n.locale,
            };

            localStorage.setItem(`cache:${type}`, JSON.stringify(cache));
        },

        /**
         * @private
         * @param {string} type
         * @param {number} cacheTime
         * @returns
         */
        getItemCatalog(type, cacheTime = DEFAULT_CACHE_TIME) {
            const item = localStorage.getItem(`cache:${type}`);

            if (!item) {
                return null;
            }

            const cache = JSON.parse(item);
            const isLanguageValid = cache.language === i18n.locale;

            if (!cache.language || !isLanguageValid) {
                return null;
            }

            if (cache.timestamp && (Date.now() - cache.timestamp) < cacheTime) {
                return cache.data;
            }

            return null;
        },

        clearItemCatalog(type) {
            localStorage.removeItem(`cache:${type}`);
        },

        clearCatalog() {
            CATALOGS.forEach(item => this.clearItemCatalog(item));
        },
    },

    watch: {
        '$i18n.locale': function() {
            if (this.setCatalogList) {
                this.setCatalogList();
            }
        },
    },
};